let Blogs = [
    {
        "id": '1',
        "text": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque.',
        "image": 'https://picsum.photos/300/250',
        "vote": 0,
        "see": 1,
        "link": '#'
    },
    {
        "id": '2',
        "text": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque.',
        "image": 'https://picsum.photos/300/250',
        "vote": 0,
        "see": 1,
        "link": '#'
    },
    {
        "id": '3',
        "text": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque.',
        "image": 'https://picsum.photos/300/250',
        "vote": 0,
        "see": 1,
        "link": '#'
    },
    {
        "id": '4',
        "text": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque.',
        "image": 'https://picsum.photos/300/250',
        "vote": 0,
        "see": 1,
        "link": '#'
    },
    
]

export default Blogs